import { render, staticRenderFns } from "./Pagostipo.vue?vue&type=template&id=73aa5f44&scoped=true"
import script from "./Pagostipo.vue?vue&type=script&lang=js"
export * from "./Pagostipo.vue?vue&type=script&lang=js"
import style0 from "./Pagostipo.vue?vue&type=style&index=0&id=73aa5f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aa5f44",
  null
  
)

export default component.exports